export default {
    getAllItems: function(data) {
        return $.request('MapHelper::onGetProductListData', {'data': data});
    },
    getCatalogPopUpItems: function(data) {
        return $.request('MapHelper::onGetProductData', {'data': data});
    },
    getProductPopUpItems: function(data) {
        return $.request('MapHelper::onGetProductData', {'data': data});
    },
    getAddressPopUpItems: function(data) {
        
        return $.request('MapHelper::onGetMapElement', {'data': data});
    },
};


// WEBPACK FOOTER //
// ./src/common/modules/MapClasses/mapApi.js